import { mapGetters } from 'vuex'
import i18n from '@/locales'
import {
  getNameDescriptionTableColumn,
  getEnabledTableColumn,
  getCopyWithContentTableColumn,
  getProjectTableColumn,
} from '@/utils/common/tableColumn'
import {
  getPublicScopeTableColumn,
  getSettingTableColumn,
  getTypeTableColumn,
  getExecTimeTableColumn,
  getPeriodTableColumn,
  getTimeFromTableColumn,
} from '@Bill/utils/columns'

export default {
  computed: mapGetters(['isAdminMode']),
  created () {
    var nameCol = {}
    if (this.isAdminMode) {
      nameCol = getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        formRules: [
          { required: true, message: i18n.t('bill.text_145') },
        ],
        message: (row) => {
          return row.name
        },
        slotCallback: (row) => {
          const typeStr = row.name
          return (
            [<side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{typeStr}</side-page-trigger>]
          )
        },
      })
    } else {
      nameCol = getCopyWithContentTableColumn({
        title: this.$t('scope.text_827'),
        hideField: true,
        message: (row) => {
          return i18n.t(`suggestsyRuleTypes.${row.type}`)
        },
        slotCallback: (row) => {
          const typeStr = i18n.t(`suggestsyRuleTypes.${row.type}`)
          return (
            <span>{ typeStr }</span>
          )
        },
      })
    }
    this.columns = [
      nameCol,
      getEnabledTableColumn(),
      {
        field: 'res_type',
        title: this.$t('bill.text_73'),
        formatter: ({ row }) => {
          return this.$t(`meter.suggest_rule_resource_type.${row.res_type}`)
        },
      },
      getSettingTableColumn(),
      getPeriodTableColumn(),
      getTimeFromTableColumn(),
      getExecTimeTableColumn({ vm: this }),
      getTypeTableColumn(),
      getProjectTableColumn({ title: this.$t('meter.scope_project') }),
      getPublicScopeTableColumn({ resource: 'suggestsysrules', vm: this, title: this.$t('bill.apply_scope') }),
    ]
  },
}
